// Canonical mode enum lives in constants. Re-exported here so the modal and its
// mode components can import it from a single, modal-local entry point.
import { DOCUMENT_SELECTION_MODES } from '@constants';

export { DOCUMENT_SELECTION_MODES };

export const generateDocumentSelectionModeName = (mode) => {
  switch (mode) {
    case DOCUMENT_SELECTION_MODES.myDocs:
      return 'Uploaded documents';
    case DOCUMENT_SELECTION_MODES.allCompany:
      return 'Search by Company / Tag';
    case DOCUMENT_SELECTION_MODES.companyTag:
      return 'Search by Company / Tag';
    case DOCUMENT_SELECTION_MODES.docType:
      return 'Search by document type';
    case DOCUMENT_SELECTION_MODES.client:
      return 'Client documents';
    case DOCUMENT_SELECTION_MODES.customMode:
      return 'Mode Specific';
    case DOCUMENT_SELECTION_MODES.website:
      return 'Website uploads';
    case DOCUMENT_SELECTION_MODES.fedDoc:
      return 'Search macro documents';
    case DOCUMENT_SELECTION_MODES.speaker:
      return 'Search by speaker';
    case DOCUMENT_SELECTION_MODES.ppm:
      return 'Search by PPM documents / side letters';
    case DOCUMENT_SELECTION_MODES.credit:
      return 'Search by credit documents';
    default:
      return 'Missing mode';
  }
};
